import React from "react";
import type { FC } from "react";

import { IndicatorCounter } from "../../../../Indicator";

import type { OmitOfUnion } from "../../../../../types/react";
import type { IndicatorCounterProps } from "../../../../Indicator";

const BUTTON_TOP_RIGHT_INDICATOR_COUNTER_DISPLAY_NAME =
    "Button.TopRightIndicatorCounter";

type ButtonTopRightIndicatorCounterProps = OmitOfUnion<
    IndicatorCounterProps,
    "size"
>;

const ButtonTopRightIndicatorCounter: FC<
    ButtonTopRightIndicatorCounterProps
> = (indicatorCounterProps) => {
    return (
        <IndicatorCounter
            data-tsid="button-top-right-indicator-counter"
            {...indicatorCounterProps}
            size="16"
        />
    );
};

ButtonTopRightIndicatorCounter.displayName =
    BUTTON_TOP_RIGHT_INDICATOR_COUNTER_DISPLAY_NAME;

export default ButtonTopRightIndicatorCounter;
